import { render, staticRenderFns } from "./Ndr.vue?vue&type=template&id=b789fb60&"
import script from "./Ndr.vue?vue&type=script&lang=js&"
export * from "./Ndr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports